/**
 * @generated SignedSource<<31fb9dbbc59bcaf791bf8f635cff373b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrandInfo_viewer$data = {
  readonly brand: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ShowBrandInfo_brand">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"EditBrandInfo_viewer">;
  readonly " $fragmentType": "BrandInfo_viewer";
};
export type BrandInfo_viewer$key = {
  readonly " $data"?: BrandInfo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrandInfo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrandInfo_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandType",
      "kind": "LinkedField",
      "name": "brand",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ShowBrandInfo_brand"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditBrandInfo_viewer"
    }
  ],
  "type": "ViewerBrand",
  "abstractKey": null
};

(node as any).hash = "6dde2608905424be0280689faec50fad";

export default node;
